/**
 * Export cheerio (with )
 */

exports = module.exports = require('./lib/cheerio');

/*
  Export the version
*/

exports.version = require('./package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/cheerio/index.js
// module id = 381
// module chunks = 168707334958949